import tImg1 from "../images/case/react-svgrepo-com.svg";
import tImg2 from "../images/case/flutter-svgrepo-com.svg";
import tImg3 from "../images/case/icon_netcore.svg";
import tImg4 from "../images/case/vuejs.svg";
import tImg5 from "../images/case/nodejs-svgrepo-com.svg";
import tImg6 from "../images/case/wordpress-color-svgrepo-com.svg";
import tImg7 from "../images/case/javascript-svgrepo-com.svg";
import tImg8 from "../images/case/icon_python.svg";

import cervicare from "../images/portfolio/CerviCare/CerviCare.png";
import cervicare1 from "../images/portfolio/CerviCare/CerviCare1.png";
import cervicare2 from "../images/portfolio/CerviCare/CerviCare2.png";
import cervicare3 from "../images/portfolio/CerviCare/CerviCare23.png";
import cervicareM1 from "../images/portfolio/CerviCare/CerviCareM1.png";
import cervicareM2 from "../images/portfolio/CerviCare/CerviCareM2.png";
import cervicareM3 from "../images/portfolio/CerviCare/CerviCareM3.png";
import cervicareM4 from "../images/portfolio/CerviCare/CerviCareM4.png";
import cervicareM5 from "../images/portfolio/CerviCare/CerviCareM5.png";
import cervicareM6 from "../images/portfolio/CerviCare/CerviCareM6.png";
import CerviCare8 from "../images/portfolio/CerviCare/CerviCare-8.png";


import mindWatch from "../images/portfolio/MindWatch/MindWatchMockUp.png";

import mindWatchLoginPage from "../images/portfolio/MindWatch/MindWatchLoginPage.png";
import mindWatchIphone1 from "../images/portfolio/MindWatch/MindWatchIphone.png";
import mindWatchTripleIphone from "../images/portfolio/MindWatch/MindWatchTripleIphone.png";


import G4 from "../images/portfolio/MindWatch/G4.png";


import dailydiary from '../images/portfolio/DigitalDiary/digitalDiary_2.png'
import dailydiary1 from '../images/portfolio/DigitalDiary/digitalDiary_1.png'
import dailydiary2 from '../images/portfolio/DigitalDiary/digitalDiary_3.png'
import dailydiary3 from '../images/portfolio/DigitalDiary/digitalDiary_4.png'
import dailydiary4 from '../images/portfolio/DigitalDiary/digitalDiary_5.png'
import dailydiary5 from '../images/portfolio/DigitalDiary/digitalDiary_6.png'
import dailydiaryM1 from '../images/portfolio/DigitalDiary/dailydairyMobile_1.png'
import dailydiaryM2 from '../images/portfolio/DigitalDiary/dailydairyMobile_2.png'


import examAnalyzer1 from '../images/portfolio/ExamAnalyzer/examAnalyzer_1.png'
import examAnalyzer2 from '../images/portfolio/ExamAnalyzer/examAnalyzer_2.png'
import examAnalyzer3 from '../images/portfolio/ExamAnalyzer/examAnalyzer_3.png'
import examAnalyzer4 from '../images/portfolio/ExamAnalyzer/examAnalyzer_4.png'
import examAnalyzerM1 from '../images/portfolio/ExamAnalyzer/examAnalyzerM_1.png'
import examAnalyzerM2 from '../images/portfolio/ExamAnalyzer/examAnalyzerM_2.png'
import examAnalyzer8 from '../images/portfolio/ExamAnalyzer/Exam-Analyzer-8.png'

import secureNet from '../images/portfolio/Secure360/secure360.png';
import secureNet1 from '../images/portfolio/Secure360/secure360_2.png';
import secureNet2 from '../images/portfolio/Secure360/secure360_3.png';
import secureNet3 from '../images/portfolio/Secure360/secure360_4.png';
import secureNetM2 from '../images/portfolio/Secure360/secure360_M.png';
import secureNetM3 from '../images/portfolio/Secure360/secure360_M2.png';
import secureNetM4 from '../images/portfolio/Secure360/secure360_M3.png';
import secureNetM5 from '../images/portfolio/Secure360/secure360_M4.png';
import SecureNet3608 from '../images/portfolio/Secure360/SecureNet-360-8.png';


import hakeem1 from '../images/portfolio/Hakeem/Hakeem-1.png';
import hakeem2 from '../images/portfolio/Hakeem/Hakeem 2.png';
import hakeem3 from '../images/portfolio/Hakeem/Hakeem-3.png';
import hakeem4 from '../images/portfolio/Hakeem/Hakeem-4.png';
import hakeem5 from '../images/portfolio/Hakeem/Hakeem 5.png';
import Hakeem8 from '../images/portfolio/Hakeem/Hakeem-8.png';



import petbuds1 from '../images/portfolio/Petbuds/Petbuds-1.png';
import petbuds2 from '../images/portfolio/Petbuds/Petbuds-2.png';
import petbuds3 from '../images/portfolio/Petbuds/Petbuds-3.png';
import petbuds4 from '../images/portfolio/Petbuds/Petbuds-4.png';
import petbuds5 from '../images/portfolio/Petbuds/Petbuds-5.png';
import Petbuds8 from '../images/portfolio/Petbuds/Petbuds-8.png';

import pos1 from '../images/portfolio/Point-of-scale/Point-of-scale-1.png';
import pos2 from '../images/portfolio/Point-of-scale/Point-of-scale-2.png';
import pos3 from '../images/portfolio/Point-of-scale/Point-of-scale-3.png';
import pos4 from '../images/portfolio/Point-of-scale/Point-of-scale-4.png';
import pos5 from '../images/portfolio/Point-of-scale/Point-of-scale-5.png';
import pos8 from '../images/portfolio/Point-of-scale/Point-of-scale-8.png';

import breachPoint1 from '../images/portfolio/Breach-Point/Breach-Point-1.png';
import breachPoint2 from '../images/portfolio/Breach-Point/Breach-Point-2.png';
import breachPoint3 from '../images/portfolio/Breach-Point/Breach-Point-3.png';
import thumbnailbreachPoint from '../images/portfolio/Breach-Point/thumbnail-Breach-Point-1.png';



import aegis1 from '../images/portfolio/Aegis-Host-Sheild/Aegis-Host-Sheild-1.png';
import aegis2 from '../images/portfolio/Aegis-Host-Sheild/Aegis-Host-Sheild-2.png';
import aegis3 from '../images/portfolio/Aegis-Host-Sheild/Aegis-Host-Sheild-3.png';
import thumbnailaegis from '../images/portfolio/Aegis-Host-Sheild/thumbnail-Aegis-Host-Sheild-1.png';

import aegisCC1 from '../images/portfolio/Aegis-Command-Center/Aegis-Command-Center-1.png';
import aegisCC2 from '../images/portfolio/Aegis-Command-Center/Aegis-Command-Center-2.png';
import aegisCC3 from '../images/portfolio/Aegis-Command-Center/Aegis-Command-Center-3.png';
import thumbnailaegisCC from '../images/portfolio/Aegis-Command-Center/thumbnail-Aegis-Command-Center-1.png';


import aegisSG1 from '../images/portfolio/Aegis-Sentinel-Gateway/Aegis-Sentinel-Gateway-1.png';
import aegisSG2 from '../images/portfolio/Aegis-Sentinel-Gateway/Aegis-Sentinel-Gateway-2.png';
import aegisSG3 from '../images/portfolio/Aegis-Sentinel-Gateway/Aegis-Sentinel-Gateway-3.png';
import aegisSG4 from '../images/portfolio/Aegis-Sentinel-Gateway/Aegis-Sentinel-Gateway-4.png';


import bidaHomes1 from '../images/portfolio/Bida-Homes/Bida-Homes-1.png';
import bidaHomes2 from '../images/portfolio/Bida-Homes/Bida-Homes-2.png';
import bidaHomes3 from '../images/portfolio/Bida-Homes/Bida-Homes-3.png';
import bidaHomes4 from '../images/portfolio/Bida-Homes/Bida-Homes-4.png';
import bidaHomes5 from '../images/portfolio/Bida-Homes/Bida-Homes-5.png';
import bidaHomes6 from '../images/portfolio/Bida-Homes/Bida-Homes-6.png';
import bidaHomes7 from '../images/portfolio/Bida-Homes/Bida-Homes-7.png';
import bidaHomes8 from '../images/portfolio/Bida-Homes/Bida-Homes-8.png';

import wbm1 from '../images/portfolio/wbm/WBM-1.png';
import wbm2 from '../images/portfolio/wbm/WBM-2.png';
import wbm3 from '../images/portfolio/wbm/WBM-3.png';
import wbm4 from '../images/portfolio/wbm/WBM-4.png';
import wbm5 from '../images/portfolio/wbm/WBM-5.png';
import wbm6 from '../images/portfolio/wbm/WBM-6.png';
import WBM8 from '../images/portfolio/wbm/WBM-8.png';


import fcb1 from '../images/portfolio/First-Choice-Billing/First-Choice-Billing-1.png';
import fcb2 from '../images/portfolio/First-Choice-Billing/First-Choice-Billing-2.png';
import fcb3 from '../images/portfolio/First-Choice-Billing/First-Choice-Billing-3.png';
import fcb4 from '../images/portfolio/First-Choice-Billing/First-Choice-Billing-4.png';
import fcb5 from '../images/portfolio/First-Choice-Billing/First-Choice-Billing-5.png';
import fcb8 from '../images/portfolio/First-Choice-Billing/First-Choice-Billing-8.png';


import ecoConnect1 from '../images/portfolio/Eco-Connect/Econnect1.png';
import ecoConnect2 from '../images/portfolio/Eco-Connect/Econnect-2.png';
import ecoConnect3 from '../images/portfolio/Eco-Connect/Econnect-3.png';
import ecoConnect4 from '../images/portfolio/Eco-Connect/Econnect-4.png';
import ecoConnect8 from '../images/portfolio/Eco-Connect/Ecoconnect-8.png';

import payperProject1 from '../images/portfolio/PayperProject/Payper-Project.png';
import payperProject2 from '../images/portfolio/PayperProject/Payper-Project-2.png';
import payperProject3 from '../images/portfolio/PayperProject/Payper-Project-3.png';
import payperProject4 from '../images/portfolio/PayperProject/Payper-Project-4.png';
import payperProject5 from '../images/portfolio/PayperProject/Payper-Project-5.png';


import tutorNearby1 from '../images/portfolio/Tutor-Nearby/Tutor-Nearby-1.png';
import tutorNearby2 from '../images/portfolio/Tutor-Nearby/Tutor-Nearby-2.png';
import tutorNearby3 from '../images/portfolio/Tutor-Nearby/Tutor-Nearby-3.png';
import tutorNearby4 from '../images/portfolio/Tutor-Nearby/Tutor-Nearby-4.png';
import TutorNearby8 from '../images/portfolio/Tutor-Nearby/TutorNearby-8.png';


import greenBellPackaging1 from '../images/portfolio/Green-Bell-Packaging/Green-Bell-Packaging-1.png';
import greenBellPackaging2 from '../images/portfolio/Green-Bell-Packaging/Green-Bell-Packaging-2.png';
import greenBellPackaging3 from '../images/portfolio/Green-Bell-Packaging/Green-Bell-Packaging-3.png';
import greenBellPackaging4 from '../images/portfolio/Green-Bell-Packaging/Green-Bell-Packaging-4.png';
import greenBellPackaging5 from '../images/portfolio/Green-Bell-Packaging/Green-Bell-Packaging-5.png';
import GreenBell8 from '../images/portfolio/Green-Bell-Packaging/GreenBell-8.png';


import boltan1 from '../images/portfolio/Boltan/Bolton-Road-Dental-Practice-1.png';
import boltan2 from '../images/portfolio/Boltan/Bolton-Road-Dental-Practice-2.png';
import boltan3 from '../images/portfolio/Boltan/Bolton-Road-Dental-Practice-3.png';
import boltan4 from '../images/portfolio/Boltan/Bolton-Road-Dental-Practice-4.png';
import boltan5 from '../images/portfolio/Boltan/Bolton-Road-Dental-Practice-5.png';


const Project = [
  {
    id: "1",
    pImg: CerviCare8,
    title: "CerviCare - AI-Powered Cervical Cancer Risk Assessment Tool",
    slug: "cervicate-risk-assessment",
    sub: "Healthcare AI",
    technologies1: "/path/to/react-icon.png",
    technologies2: "/path/to/ml-icon.png",
    description:
      "CerviCare is a healthcare solution built to improve early detection and prevention of cervical cancer, especially in underserved areas. By using clinically validated data and the AdaBoost machine learning algorithm, it produces personalized risk assessments that support timely diagnosis and targeted interventions.",
    services: " AI-Driven Health Risk Assessment",
    Industry: " Global Health Innovations",
    location: " San Francisco, CA",
    projectRequirement: "The project required the design and implementation of an AI-driven health assessment platform that utilizes the AdaBoost algorithm to evaluate cervical cancer risk with personalized accuracy. Key requirements included an intuitive multi-screen user interface, secure handling of sensitive health data, evidence-based risk profiling, and the ability to generate actionable insights and recommendations for early intervention and awareness.",
    completedDate: " 15-07-2024",
    category: "healthcare",
    solutionResult: "The solution involved implementing machine learning algorithms, specifically the AdaBoost classifier, to assess cervical cancer risk based on clinical data. The system was designed to provide healthcare professionals with a tool for identifying patients at high risk, aiding early diagnosis and intervention. The result was a highly accurate risk assessment tool that could be integrated into healthcare systems to improve patient outcomes and reduce cervical cancer mortality. The use of AdaBoost enabled enhanced feature selection and ensemble decision-making, significantly improving diagnostic precision. This helped reduce false positives while maintaining high sensitivity for early-stage risk detection.",
    features: [
      "AI-powered risk evaluation using AdaBoost algorithm",
      "Personalized cervical cancer risk assessment",
      "User-friendly multi-screen interface for seamless navigation",
      "Real-time risk analysis and data processing",
      "Secure management of sensitive health data",
      "Explainable AI-driven insights for transparency",
      "Adherence to healthcare data privacy and regulatory standards",
      "Actionable health insights with early intervention recommendations",
      "Localization support for multilingual users",
      "Integration with electronic health record (EHR) systems",
      "Mobile-responsive design for field use in remote areas",
      "Compliant with HIPAA and GDPR for data protection",
    ],
    Technologies1: tImg1,
    Technologies2: tImg8,
    additionalImages: [
      cervicare,
      cervicare1,
      cervicare2,
      cervicare3,
      cervicareM1,
      cervicareM2,
      cervicareM3,
      cervicareM4,
      cervicareM5,
      cervicareM6,
    ],
  },
  {
    id: "2",
    pImg: mindWatch,
    title: "MindWatch - Mental Health Prediction via Twitter Analysis",
    slug: "mindwatch-mental-health",
    sub: "Social Media AI",
    technologies1: "/path/to/twitter-icon.png",
    technologies2: "/path/to/ml-icon.png",
    description:
      "MindWatch harnesses the power of Natural Language Processing (NLP) and real-time social media sentiment tracking to monitor mental health cues. The system targets public health agencies and researchers aiming to proactively identify mental health trends, empowering preventive intervention.",
    services: " Mental Health Monitoring",
    projectRequirement: "The project required the development of an AI-driven application capable of analyzing real-time Twitter data to identify indicators of mental health conditions. Leveraging Support Vector Machine (SVM) classification and activity theory, the system needed to extract, process, and interpret user sentiment and behavioral patterns with high accuracy, ensuring ethical data use, privacy compliance, and actionable insights for mental health monitoring.",
    Industry: " Health and Wellbeing",
    location: " New York, NY",
    completedDate: " 20-08-2024",
    category: "technology",
    solutionResult: "For this project, an AI-driven solution was created to analyze Twitter data, identifying mental health trends and sentiments among users. Natural Language Processing (NLP) and sentiment analysis were utilized to detect signs of mental health issues like depression and anxiety. The result was a platform that provided real-time insights for mental health professionals, helping to monitor and respond to emerging mental health trends in social media. The system achieved 88% accuracy in classifying emotional states using SVM and BERT-based models. It supported the early identification of depression markers in tweets with only minimal input, significantly improving outreach potential.",
      features: [
        "Real-time Twitter data analysis",
        "SVM-based sentiment classification",
        "Behavioral pattern identification",
        "Ethical data use and privacy compliance",
        "Actionable mental health insights",
        "Sentiment and emotional state tracking",
        "Context-aware sentiment analysis",
        "Reports for mental health professionals",
        "Continuous model improvement",
        "Time-based trend analysis to detect worsening emotional patterns",
        "Mental health condition tagging (e.g., anxiety, depression, burnout)",
        "Dashboard for psychologists and mental health organizations",
        "Compliant with HIPAA and GDPR for data protection",
        "Multilingual sentiment detection for global mental health monitoring"
      ],
    Technologies1: tImg4,
    Technologies2: tImg5,
    additionalImages: [
      mindWatch,
      mindWatchLoginPage,
      //MindWatch1,
      //MindWatch2,
      //MindWatch3,
      mindWatchTripleIphone,
      mindWatchIphone1,
      G4
      
    ],
  },
  {
    id: "3",
    pImg: SecureNet3608,
    title: "SecureNet360 - Distributed AI Surveillance System",
    slug: "securenet-ai-surveillance",
    sub: "Security Intelligence",
    technologies1: "/path/to/cnn-icon.png",
    technologies2: "/path/to/blockchain-icon.png",
    description:
      "SecureNet360 represents the convergence of AI and blockchain in the surveillance space. Designed for use in airports, corporate campuses, and public infrastructure, this distributed surveillance solution provides a tamper-proof and intelligent monitoring ecosystem.",
    services: " AI-Powered Surveillance and Security Intelligence",
    projectRequirement: "The project required the development of a next-generation distributed surveillance system integrating convolutional neural networks (CNN) for intelligent threat detection, blockchain for tamper-proof activity logging, and real-time inter-camera communication. The solution demanded high reliability, low-latency processing, and advanced security protocols to ensure robust monitoring and data integrity across multiple locations.",
    Industry: " Security Industry Authority",
    location: " London, UK",
    completedDate: " 10-09-2024",
    category: "security",
    features: [
      "CNN-powered intelligent threat detection",
      "Blockchain for tamper-proof activity logging",
      "Real-time inter-camera communication",
      "Low-latency data processing",
      "High-reliability surveillance system",
      "Advanced security protocols and encryption",
      "Distributed network management",
      "Scalable multi-location support",
      "Automated incident reporting and alerts",
      "Threat prioritization and escalation workflow",
      "Blockchain-based access logs for auditability",
      "Real-time facial recognition alerts",
      "GDPR/CCPA/ICO/BIPA Compliance",
      "Anomaly detection using unsupervised learning algorithms",
    ],
    solutionResult: "The solution involved combining intelligent surveillance using Convolutional Neural Networks (CNN) with blockchain technology for secure and tamper-proof data logging. The system monitored physical environments for security breaches, and each event was recorded in an immutable blockchain ledger, ensuring transparency and security. The result was a highly secure and efficient surveillance system that provided real-time alerts and could be used in a variety of industries requiring stringent security measures. CNNs achieved over 92% precision in detecting suspicious activities. Events logged on the blockchain ensured forensic integrity, providing an invaluable audit trail for security teams and law enforcement agencies.",
    Technologies1: tImg3,
    Technologies2: tImg5,
    additionalImages: [
      secureNet,
      secureNet1,
      secureNet2,
      secureNet3,
      secureNetM2,
      secureNetM3,
      secureNetM4,
      secureNetM5

    ]

  },
  {
    id: "4",
    pImg: dailydiary,
    title: "DigitalDiary - Comprehensive EdTech Management Platform",
    slug: "digitaldiary-school-management",
    sub: "Educational Technology",
    technologies1: "/path/to/react-icon.png",
    technologies2: "/path/to/ai-icon.png",
    description:
      "DigitalDiary transforms traditional school management into a modern digital experience by offering centralized performance tracking, parental engagement, and AI-driven recommendations to educators. Its modular design supports primary, secondary, and special education institutions.",
    services: " Educational Platform Development",
    Industry: " Education",
    location: " Manchester, UK",
    completedDate: " 02-01-2025",
    projectRequirement: "The project required the development of a unified, secure, and user-friendly EdTech platform enabling seamless collaboration between teachers, parents, and school administrators. Key requirements included AI-driven student performance analysis, real-time communication modules, and comprehensive school management tools tailored to support academic and administrative operations effectively.",
    category: "helpdesk",
    features: [
      "Role-based access control",
      "AI-driven performance analysis",
      "Real-time messaging and alerts",
      "School management tools",
      "Secure data handling",
      "Customizable dashboards",
      "Automated reporting",
      "System integration",
      "Attendance anomaly detection via AI",
      "Homework and test management modules",
      "Push notifications for real-time school events",
      "DPIA/GDPR/FERPA Compliance"
    ],
    solutionResult: "The solution aimed to create a digital diary for students, utilizing AI to assess academic performance, providing insights into strengths and areas for improvement. The platform also offered secure messaging and communication tools for students and educators. The result was an interactive, AI-powered educational platform that not only allowed students to track their learning progress but also facilitated secure and seamless communication between students and teachers. Implemented in over 15 institutions within the UK, DigitalDiary improved parental engagement by 62% and streamlined academic reporting with AI-generated performance summaries for each student.",
    Technologies1: tImg2,
    Technologies2: tImg5,
    additionalImages: [
      dailydiary,
      dailydiary1,
      dailydiary2,
      dailydiary3,
      dailydiary4,
      dailydiary5,
      dailydiaryM1,
      dailydiaryM2,
    ]
  },
  {
    id: "5",
    pImg: examAnalyzer8,
    title: "ExamAnalyzer Web - Advanced Exam Performance Analytics",
    slug: "examanalyzer-performance-insights",
    sub: "Educational Analytics",
    technologies1: "/path/to/ai-icon.png",
    technologies2: "/path/to/data-analysis-icon.png",
    description:
      "ExamAnalyzer Web provides an edge to academic institutions by combining predictive analytics with deep-dive insights into exam trends, question difficulty, and individualized student learning paths.",
    services: " Educational Performance Analysis",
    Industry: " Education",
    location: " Birmingham, UK",
    completedDate: " 25-03-2025",
    category: "analysis",
    projectRequirement: "The project required the development of a secure, scalable, and intuitive web-based platform capable of analyzing large volumes of exam data using AI-driven algorithms. Key deliverables included customizable performance dashboards, granular student-level insights, predictive analytics for learning outcomes, and integration with existing academic systems. The system needed to support real-time reporting, role-based access, and data privacy compliance (GDPR). Additionally, comprehensive training and ongoing support were essential to ensure smooth adoption and long-term success for educators and administrators.",
    features: [
      "AI-powered exam insights",
      "Question-level performance analysis",
      "Granular student insights",
      "Real-time reporting",
      "Predictive learning analytics",
      "GDPR-compliant data handling",
      "Customizable dashboards",
      "Role-based access control",
      "Trend comparison across cohorts",
      "Difficulty-level tagging per question",
      "Teacher performance analytics via student improvement graphs",
      "DPIA/GDPR/FERPA Compliance",
    ],
    solutionResult: "This project utilized AI to analyze student performance data and generate predictive analytics and reports for educators. The solution provided insights into trends in exam results, helping educators identify areas where students needed additional support. The result was an AI-driven platform that enhanced the efficiency of grading and feedback, allowing educators to make data-informed decisions to improve student learning outcomes. The system empowered educators to focus intervention efforts precisely where needed, reducing grade repetition by 20% in pilot schools. Predictive models identified students at risk based on performance and engagement data.",
    Technologies1: tImg6,
    Technologies2: tImg7,
    additionalImages: [
      examAnalyzer1,
      examAnalyzer2,
      examAnalyzer3,
      examAnalyzer4,
      examAnalyzerM1,
      examAnalyzerM2,
    ]
  },
  {
    id: "6",
    pImg: Hakeem8,
    title: "Hakeem - Online Healthcare Platform",
    slug: "hakeem-healthcare-platform",
    sub: "Healthcare Technology",
    description:
      "Hakeem is an online healthcare platform designed to connect patients with verified doctors across multiple medical specialties, all in one place. The platform simplifies doctor discovery and appointment booking through smart filters and an intuitive user experience.",
    services: " Website Strategy, UI/UX Design, Frontend & Backend Development, Appointment System Integration, Performance Optimization",
    Industry: " Healthcare",
    location: " Islamabad, Pakistan",
    completedDate: " 15-01-2025",
    category: "healthcare",
    projectRequirement: "Finding the right doctor quickly was a major pain point for users. Existing solutions lacked centralized doctor listings, easy appointment booking, smart filtering by location and specialty, and scalable management for doctors, patients, and administrators. Hakeem required a secure, scalable, and user-friendly digital healthcare solution.",
    solutionResult: "Laskon Technologies designed and developed a complete end-to-end healthcare platform that enables patients to discover doctors, book appointments, and manage healthcare interactions seamlessly, while giving administrators full control over the system. The platform was built with performance, scalability, and usability at its core. Hakeem successfully transformed a complex healthcare workflow into a simple, digital-first experience — resulting in faster doctor discovery, simplified appointment booking, improved patient engagement, efficient healthcare management, and a scalable platform ready for expansion.",
    features: [
      "Doctor Discovery & Search",
      "Appointment Booking System",
      "Filters by City, Specialty & Doctor",
      "Feedback & Reviews",
      "Multi-language Support",
      "Online Chat Integration",
      "Google Map Integration",
      "Secure Login Panel",
      "Dashboard Creation",
      "Analytics & Reporting",
      "Database Structure Design",
      "Error Reports Management",
      "Crawler Control",
      "Cross-browser Compatibility",
      "Doctors Management",
      "User & Role Management",
      "Administrator Management",
      "Packages & Insurance Management",
      "Medicine Management",
      "Health Feeds Management",
      "CMS (Content Management System)",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      hakeem1,
      hakeem2,
      hakeem3,
      hakeem4,
      hakeem5,
    ],
  },
  {
    id: "7",
    pImg: Petbuds8,
    title: "Petbuds - Pet Care Marketplace Platform",
    slug: "petbuds-pet-care-platform",
    sub: "Pet Care Technology",
    description:
      "Petbuds is a two-sided digital platform that connects pet owners with trusted pet carers. The platform enables pet owners to post service requests and receive quotes from carers, while allowing both parties to communicate, manage bookings, and handle payments seamlessly.",
    services: " Product Strategy & Planning, UI/UX Design, Backend Development, Role & Booking Logic, Payment Integration, Platform Optimization",
    Industry: " Pet Care Services",
    location: " London, UK",
    completedDate: " 10-03-2025",
    category: "technology",
    projectRequirement: "Pet owners often struggle to find reliable carers for their pets, while pet carers lack a centralized platform to discover service opportunities. Existing solutions were fragmented and lacked structured booking workflows, real-time communication, transparent pricing and payments, and activity tracking for pet services. The client needed a secure, user-friendly marketplace built specifically for pet care services.",
    solutionResult: "Laskon Technologies designed and developed Petbuds, a scalable mobile-first platform supporting two user roles: Pet Owner and Pet Carer. The system enables pet owners to post service requests, receive and compare quotes, book carers, and manage pet-related activities, all within one application. The result was a simplified pet care booking process, increased trust through transparency and tracking, improved communication between owners and carers, a centralized platform for pet service management, and a scalable solution ready for future service expansion.",
    features: [
      "Post Creation for Pet Care Services",
      "View & Compare Quotes",
      "Booking Management",
      "Tracked Walks",
      "Image Gallery",
      "Service Records",
      "Check-In / Check-Out Monitoring",
      "Payment Management",
      "Browse Listings",
      "Post Quotes on Service Requests",
      "Booking & Schedule Management",
      "Check-In / Check-Out Services",
      "Service History Tracking",
      "Pet Owner Management",
      "Pet Carer Management",
      "Listings Management",
      "Secure Payment Handling",
      "Role-based User System",
      "Secure Real-time Messaging",
      "Scalable Backend for Two-sided Interactions",
      "Payment Gateway Integration",
      "Mobile-optimized User Experience",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      petbuds1,
      petbuds2,
      petbuds3,
      petbuds4,
      petbuds5,
    ],
  },
  {
    id: "8",
    pImg: pos8,
    title: "Point of Scale - Complete POS Business Management Platform",
    slug: "point-of-scale-pos-platform",
    sub: "Business Management",
    description:
      "The Point of Sale Solution is a complete business management platform designed to handle sales transactions, inventory, customer data, employee performance, and financial records within a single system. It enables organizations to monitor daily operations, control costs, and make informed decisions through centralized data and analytics.",
    services: " System Architecture Design, UI/UX Design, Backend Development, Database Structuring, Performance Optimization, Testing & Deployment, Ongoing Technical Support",
    Industry: " Retail & Business Operations",
    location: " Dubai, UAE",
    completedDate: " 20-02-2025",
    category: "technology",
    projectRequirement: "Businesses often rely on multiple disconnected systems to manage sales, inventory, employees, and accounts. This leads to data inconsistency, manual reconciliation, poor visibility into operations, and inefficient decision-making. The client needed an all-in-one POS solution capable of managing every transaction and operational workflow efficiently.",
    solutionResult: "Laskon Technologies designed and developed a centralized POS platform that integrates sales management, inventory control, HR reviews, and financial tracking into one scalable system. The solution was built to ensure speed, accuracy, and real-time visibility across all organizational transactions. The result was centralized business control under one system, reduced manual reporting errors, faster transaction processing, improved inventory accuracy, and clear financial visibility.",
    features: [
      "Dashboard Creation",
      "Database Structure & Schema Design",
      "Optimized Code for Fast Page Loading",
      "Cross-Platform Compatibility",
      "Order Management & Tracking",
      "Sales Monitoring",
      "Search & Quick Transactions",
      "Product Management",
      "AD Inventory Management",
      "Stock Tracking & Updates",
      "Product Performance Monitoring",
      "Employee Performance Tracking",
      "HR Reviews & Reporting",
      "Accounts Management",
      "Transaction Records",
      "Financial Reporting",
      "Revenue Insights",
      "Real-Time Data Visualization",
      "Sales Reports",
      "Operational Insights",
      "CMS Integration",
      "User Management",
      "Role-Based Access Control",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      pos1,
      pos2,
      pos3,
      pos4,
      pos5,
    ],
  },
  {
    id: "9",
    pImg: thumbnailbreachPoint,
    title: "BreachPoint - Proactive Cybersecurity Testing Platform",
    slug: "breachpoint-cybersecurity-platform",
    sub: "Cybersecurity",
    description:
      "BreachPoint is a proactive cybersecurity testing platform designed to simulate real-world cyberattacks and uncover vulnerabilities before malicious actors can exploit them. The platform enables organizations to continuously assess their security posture without disrupting daily operations. Its core mission: detect weaknesses early, validate defenses, and reduce security risks intelligently.",
    services: " Platform Architecture & Security Framework, Attack Simulation Engine Development, Automation Workflow Design, Risk Analytics & Reporting Dashboard, Performance Optimization, Secure Deployment & Testing",
    Industry: " Cybersecurity",
    location: " Austin, TX",
    completedDate: " 05-03-2025",
    category: "security",
    projectRequirement: "Modern organizations face increasingly sophisticated cyber threats, delayed vulnerability detection, manual and time-consuming penetration testing, limited visibility into security gaps, and operational disruption during security audits. A scalable, automated, and non-intrusive solution was required to ensure continuous protection.",
    solutionResult: "We developed BreachPoint as an automated, intelligent cybersecurity testing platform capable of simulating real-world attack scenarios in a controlled environment. The platform delivers proactive defense that prevents breaches before they occur, continuous monitoring ensuring zero blind spots, an analytics engine that learns from every simulation, real-time detection and response, unified integration of all security tools, and full automation eliminating manual testing. The impact includes early identification of critical vulnerabilities, reduced security risks, faster remediation cycles, improved compliance readiness, and strengthened overall cybersecurity posture.",
    features: [
      "Automated Penetration Testing",
      "Continuous Security Assessments",
      "Real-Time Vulnerability Scanning",
      "Risk Scoring & Threat Prioritization",
      "Security Control Validation",
      "Detailed Remediation Reports",
      "Compliance-Ready Reporting",
      "Secure & Scalable Architecture",
      "Proactive Defense System",
      "Continuous Monitoring with Zero Blind Spots",
      "Analytics Engine with Learning Capabilities",
      "Real-Time Detection & Response",
      "Unified Security Tools Integration",
      "Full Automation of Manual Testing",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      breachPoint1,
      breachPoint2,
      breachPoint3,
    ],
  },
  {
    id: "10",
    pImg: thumbnailaegis,
    title: "Aegis Host Shield - Comprehensive Server Security Solution",
    slug: "aegis-host-shield",
    sub: "Server Security",
    description:
      "Aegis Host Shield is a comprehensive server security solution built to protect critical infrastructure from modern cyber threats. Designed with a multi-layered defense architecture, the platform combines intrusion prevention, web application firewall (WAF), malware detection, and file integrity monitoring into a single, high-performance system. It ensures servers remain secure, compliant, and resilient, without compromising speed or operational efficiency.",
    services: " Security Architecture Design, Backend Development, Threat Detection Engine Integration, Real-Time Monitoring System, Dashboard & UI Development, Performance Optimization, Deployment & Infrastructure Setup",
    Industry: " Cybersecurity",
    location: " Washington, DC",
    completedDate: " 15-03-2025",
    category: "security",
    projectRequirement: "Organizations face increasing risks such as server-level attacks and intrusion attempts, web application vulnerabilities, malware injections and ransomware threats, unauthorized file modifications, and compliance and audit complexities. Businesses needed a centralized yet lightweight solution that delivers real-time protection without affecting server performance.",
    solutionResult: "We engineered Aegis Host Shield as a scalable, enterprise-ready server defense system that provides brute-force and intrusion prevention, web application firewall (WAF), file integrity monitoring, malware and rootkit detection, and automated reporting with multi-channel alerts. The impact includes strengthened server-level protection, reduced risk of unauthorized access, improved compliance readiness, faster threat detection and response, and enhanced infrastructure resilience.",
    features: [
      "Intrusion Prevention System (IPS)",
      "Web Application Firewall (WAF)",
      "Malware Detection & Scanning",
      "File Integrity Monitoring",
      "Real-Time Threat Alerts",
      "Server Activity Monitoring",
      "Compliance & Audit Logs",
      "Access Control & Role Management",
      "Dashboard & Reporting",
      "Automated Security Updates",
      "Brute-Force & Intrusion Prevention",
      "Malware and Rootkit Detection",
      "Automated Reporting and Multi-Channel Alerts",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      aegis1,
      aegis2,
      aegis3,
    ],
  },
  {
    id: "11",
    pImg: thumbnailaegisCC,
    title: "Aegis Command Center - Unified Security Management Platform",
    slug: "aegis-command-center",
    sub: "Security Operations",
    description:
      "Aegis Command Center is a unified security management platform built to provide complete visibility across networks, servers, and security operations. The goal was to eliminate fragmented monitoring tools and bring threat detection, compliance tracking, and incident response into a single intelligent dashboard. The platform was designed specifically for enterprise and multi-client environments, enabling security teams to make faster, data-driven decisions while maintaining operational efficiency.",
    services: " System Architecture Planning, Dashboard UI/UX Design, Security Module Development, Automation Workflow Integration, Multi-tenant Infrastructure Setup, Performance Optimization, Testing & Deployment",
    Industry: " Cybersecurity",
    location: " New York, NY",
    completedDate: " 25-03-2025",
    category: "security",
    projectRequirement: "Organizations were using multiple disconnected tools for monitoring, reporting, and response. This created delayed threat detection, slow incident response times, lack of centralized visibility, complex compliance tracking, and operational inefficiencies. A scalable, centralized solution was required to unify these systems without disrupting existing infrastructure.",
    solutionResult: "We developed a secure, cloud-based command center that consolidates real-time monitoring, automation, compliance insights, and analytics into one powerful interface. The platform features unified orchestration connecting all tools into one ecosystem, an AI intelligence layer that learns from every event and improves defenses, proactive defense that predicts and prevents cyber threats automatically, visibility and control monitoring multi-client operations from one hub, and faster response detecting and resolving incidents in real time. The impact includes faster incident response time, improved operational efficiency, enhanced visibility across systems, reduced manual security workload, and a scalable solution for enterprise growth.",
    features: [
      "Real-time Security Monitoring",
      "Incident Response Automation",
      "Compliance & Audit Insights",
      "Role-Based Access Control",
      "Multi-Tenant Management",
      "Advanced Analytics Dashboard",
      "Alert & Notification System",
      "Secure Data Management",
      "Unified Orchestration",
      "AI Intelligence Layer",
      "Proactive Defense",
      "Visibility & Control Hub",
      "Real-Time Incident Resolution",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      aegisCC1,
      aegisCC2,
      aegisCC3,
    ],
  },
  {
    id: "12",
    pImg: aegisSG1,
    title: "Aegis Sentinel Gateway - Advanced Network Defense Solution",
    slug: "aegis-sentinel-gateway-network-defense",
    sub: "Network Security",
    description:
      "Aegis Sentinel Gateway is an advanced network defense solution built to secure organizations at the perimeter level. Designed with hardened architecture and AI-powered threat intelligence, it prevents malicious traffic from entering internal systems. The platform delivers proactive protection, real-time monitoring, and intelligent attack prevention — all at the network edge.",
    services: " Security Architecture Design, AI Threat Detection Integration, IPS Configuration & Optimization, Gateway System Hardening, Real-time Monitoring Dashboard Development, Performance Tuning & Secure Deployment",
    Industry: " Cybersecurity",
    location: " Washington, DC",
    completedDate: " 20-03-2025",
    category: "security",
    projectRequirement: "Organizations face increasingly complex network-based attacks, zero-day exploits and evolving malware, limited real-time visibility at the perimeter, high dependency on reactive security measures, and performance trade-offs in traditional firewalls. A modern solution was required to provide intelligent, automated, and high-speed protection at the gateway level.",
    solutionResult: "We developed Aegis Sentinel Gateway as a hardened perimeter defense system integrating firewall intelligence that analyzes and blocks threats before they breach the system, cloud security that safeguards data and services across hybrid environments, network analytics that monitors traffic and detects anomalies in real time, real-time defense that responds instantly to active cyberattacks and intrusions, and automated response that executes AI-driven actions to contain and eliminate threats. The impact includes strengthened perimeter security, reduced network intrusion risks, improved threat response time, enhanced visibility across incoming traffic, and enterprise-grade scalable defense.",
    features: [
      "Hardened Gateway Architecture",
      "AI-Powered Threat Detection",
      "Intrusion Prevention System (IPS)",
      "Real-Time Traffic Monitoring",
      "Automated Threat Blocking",
      "Zero-Day Attack Detection",
      "Advanced Network Analytics",
      "High-Performance Packet Processing",
      "Scalable Enterprise Deployment",
      "Firewall Intelligence",
      "Cloud Security Integration",
      "Real-Time Defense Response",
      "AI-Driven Automated Response",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      aegisSG1,
      aegisSG2,
      aegisSG3,
      aegisSG4,
    ],
  },
  {
    id: "13",
    pImg: bidaHomes8,
    title: "Bida Homes - Construction & Real Estate Management Platform",
    slug: "bida-homes-construction-real-estate",
    sub: "Construction / Real Estate",
    description:
      "Bida Homes is a real estate and construction company focused on delivering affordable luxury homes and commercial spaces. The company blends architectural expertise, engineering precision, and property management to ensure high-quality construction with modern design and on-time delivery. The goal was to develop a structured digital system that supports project lifecycle management, from planning to completion.",
    services: "System Architecture Planning, UI/UX Design, Backend Development, Engineering Data Structuring, Performance Optimization",
    Industry: " Construction / Real Estate",
    location: " Ghana, Africa",
    completedDate: " 07-04-2026",
    category: "technology",
    projectRequirement: "Bida Homes required a centralized system to manage construction projects, real-time monitoring of project progress, accurate architectural and structural data management, efficient material and resource tracking, quality assurance monitoring, and sustainability performance tracking. The challenge was creating a platform that integrates technical engineering workflows with operational project management.",
    solutionResult: "We built a comprehensive construction management platform that supports planning, execution, monitoring, and reporting, all within a structured and scalable framework. The system enables seamless coordination between architects, engineers, project managers, and stakeholders. The platform features a clean enterprise dashboard interface, structured data visualization, blueprint-style visual language, performance-focused UI for technical teams, and responsive design for on-site accessibility. The impact includes improved construction workflow efficiency, enhanced coordination between teams, reduced material wastage, better timeline adherence, and increased project transparency.",
    features: [
      "Project Onboarding System",
      "Site Data Mapping",
      "Architectural Design Modeling",
      "Engineering & Technical Control",
      "Structural Engineering Analysis",
      "Construction Quality Assurance",
      "Sustainability & Efficiency Metrics",
      "Progress Monitoring Dashboard",
      "Material & Resource Management",
      "Clean Enterprise Dashboard Interface",
      "Structured Data Visualization",
      "Blueprint-Style Visual Language",
      "Performance-Focused UI for Technical Teams",
      "Responsive Design for On-Site Accessibility",
      "Optimized for Performance and Scalability",
      "Secure Project Data Management",
      "Real-Time Monitoring Capabilities",
      "Cross-Platform Accessibility",
      "Modular Backend Architecture",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      bidaHomes1,
      bidaHomes2,
      bidaHomes3,
      bidaHomes4,
      bidaHomes5,
      bidaHomes6,
      bidaHomes7,
    ],
  },
  {
    id: "14",
    pImg: WBM8,
    title: "WBM International - Global Consumer Brand Digital Ecosystem",
    slug: "wbm-international-global-consumer-brand",
    sub: "Consumer Goods / Lifestyle",
    description:
      "WBM International is a globally recognized brand offering smart home, personal care, food, and lifestyle products. With a strong commitment to innovation, sustainability, and international quality standards, WBM delivers trusted consumer solutions backed by a 100% satisfaction guarantee. The objective was to design a scalable digital ecosystem that reflects WBM's global presence, diverse product lines, and operational excellence.",
    services: " Corporate Digital Strategy, UX/UI Design, System Architecture, Product Structuring, Performance Optimization",
    Industry: " Consumer Goods / Lifestyle",
    location: " Global",
    completedDate: " 09-04-2026",
    category: "technology",
    projectRequirement: "WBM International required a centralized digital ecosystem to manage diverse product lines spanning smart home, personal care, food, and lifestyle categories, real-time visibility across global distribution networks, accurate product and compliance data management, efficient supply chain transparency, quality assurance and certification tracking, and sustainability performance monitoring. The challenge was creating a platform that integrates corporate brand presentation with operational product management across international markets.",
    solutionResult: "We developed a modern, enterprise-grade digital framework that showcases WBM's global brand strength while supporting product management, compliance visibility, and supply chain transparency. The system ensures seamless coordination across departments from innovation and manufacturing to distribution. The platform features a premium corporate interface, clean structured layout for multi-category products, international brand-focused visuals, trust-driven design language, and a mobile and cross-browser optimized experience. The impact includes strengthened global brand presence, improved product management efficiency, enhanced compliance visibility, transparent supply chain operations, and a scalable foundation for international growth.",
    features: [
      "Corporate Overview",
      "Global Distribution Network",
      "Product & Innovation Management",
      "Product Development & Innovation",
      "Smart Technology Integration",
      "Quality Assurance & Certifications",
      "Food Safety & Supply Chain",
      "Sustainability & Eco Compliance",
      "Health & Consumer Solutions",
      "Health & Wellness Solutions",
      "Scalable Cloud-Based Infrastructure",
      "Secure Data and Compliance Management",
      "Modular Product Categorization System",
      "High-Performance Optimization",
      "Enterprise-Ready Backend Structure",
      "Premium Corporate Interface",
      "Clean, Structured Layout for Multi-Category Products",
      "International Brand-Focused Visuals",
      "Trust-Driven Design Language",
      "Mobile and Cross-Browser Optimized Experience",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      wbm1,
      wbm2,
      wbm3,
      wbm4,
      wbm5,
      wbm6,
    ],
  },
  {
    id: "15",
    pImg: fcb8,
    title: "First Choice Billing - Medical Billing & Revenue Cycle Management Platform",
    slug: "first-choice-billing-rcm-platform",
    sub: "Healthcare / Medical Billing",
    description:
      "First Choice Billing Solutions is a full-service Medical Billing and Revenue Cycle Management (RCM) platform designed to help healthcare providers streamline operations, maximise revenue, and reduce administrative workload. The platform manages the entire revenue lifecycle, from claims submission to payment reconciliation, ensuring financial accuracy, compliance, and operational efficiency.",
    services: " System Architecture Planning, UI/UX Design, Workflow Automation, Backend Development, Compliance Integration, Performance Optimization",
    Industry: " Healthcare / Medical Billing",
    location: " United States",
    completedDate: " 09-04-2026",
    category: "healthcare",
    projectRequirement: "Healthcare providers were struggling with delayed claim processing, high denial rates, revenue leakage, complex compliance requirements, and time-consuming administrative tasks. They needed a structured, end-to-end billing system that improves revenue flow while reducing operational stress.",
    solutionResult: "We developed a complete RCM ecosystem that automates workflows, strengthens compliance, and provides real-time financial visibility. The system ensures faster reimbursements, improved claim acceptance rates, and data-driven financial decision-making. The platform features optimized billing workflows, secure cloud-based architecture, scalable multi-provider support, real-time financial tracking, and cross-platform compatibility, all wrapped in a clean financial dashboard UI with structured workflow automation, role-based access control, HIPAA-aligned data protection, and secure financial reporting modules. The impact includes improved claim acceptance rates, faster reimbursement cycles, reduced administrative burden, better AR management, and increased revenue transparency.",
    features: [
      "Eligibility & Benefits Verification",
      "Denial Management & Appeals",
      "Accounts Receivable (AR)",
      "Payment Posting & Reconciliation",
      "Provider Enrollment & Credentialing Support",
      "Patient Billing",
      "Financial Intelligence",
      "Prior Authorization Assistance",
      "Compliance & Security Controls",
      "Communication & Support Tools",
      "Training & Best Practices Guidance",
      "AR Aging Reports",
      "Monthly Financial Statements",
      "Revenue Cycle Strategy Management",
      "Clean Financial Dashboard UI",
      "Structured Workflow Automation",
      "Role-Based Access Control",
      "HIPAA-Aligned Data Protection",
      "Secure Financial Reporting Modules",
      "Optimized Billing Workflows",
      "Secure Cloud-Based Architecture",
      "Scalable System for Multi-Provider Support",
      "Real-Time Financial Tracking",
      "Cross-Platform Compatibility",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      fcb1,
      fcb2,
      fcb3,
      fcb4,
      fcb5,
    ],
  },
  {
    id: "16",
    pImg: ecoConnect8,
    title: "Eco-Connect - Environmental Connectivity Platform",
    slug: "eco-connect-environmental-platform",
    sub: "Environmental Technology",
    description:
      "Eco-Connect is an innovative platform designed to foster environmental connectivity and promote sustainable practices through advanced technological solutions. It connects communities, organizations, and individuals in efforts to monitor, analyze, and improve environmental health and sustainability.",
    services: " Environmental Monitoring & Connectivity",
    Industry: " Environmental Technology",
    location: " Global",
    projectRequirement: "The project required the development of a comprehensive platform to connect environmental stakeholders, provide real-time monitoring capabilities, and facilitate data-driven decision making for sustainability initiatives.",
    completedDate: " 15-10-2024",
    category: "technology",
    solutionResult: "Eco-Connect was built as a scalable platform that integrates IoT sensors, data analytics, and community engagement tools to create a connected ecosystem for environmental protection. The solution enables real-time environmental monitoring, predictive analytics for sustainability trends, and collaborative tools for community-driven conservation efforts.",
    features: [
      "Real-time environmental monitoring",
      "IoT sensor integration",
      "Data analytics and visualization",
      "Community engagement tools",
      "Predictive sustainability insights",
      "Collaborative conservation platforms",
      "Mobile-responsive design",
      "API integrations for third-party tools",
    ],
    Technologies1: tImg1,
    Technologies2: tImg7,
    additionalImages: [
      ecoConnect1,
      ecoConnect2,
      ecoConnect3,
      ecoConnect4,
    ],
  },
  {
    id: "17",
    pImg: payperProject1,
    title: "PayperProject - Flexible Payment Solutions Platform",
    slug: "payperproject-payment-platform",
    sub: "Fintech / Payment Solutions",
    description:
      "PayperProject is a comprehensive payment solutions platform designed to provide flexible, secure, and efficient payment processing for projects and businesses. It offers customizable payment plans, real-time tracking, and seamless integration with various financial systems to streamline project-based transactions.",
    services: " Payment Processing & Financial Solutions",
    Industry: " Fintech / Project Management",
    location: " Global",
    projectRequirement: "The project required the development of a scalable payment platform that supports project-based billing, flexible payment schedules, and secure transaction processing with comprehensive reporting and analytics.",
    completedDate: " 20-11-2024",
    category: "technology",
    solutionResult: "PayperProject was developed as a robust fintech platform that enables businesses to manage project-based payments efficiently. The solution includes automated invoicing, milestone-based payments, escrow services, and detailed financial reporting. It integrates with popular accounting software and provides real-time payment tracking and notifications.",
    features: [
      "Flexible payment scheduling",
      "Milestone-based invoicing",
      "Secure escrow services",
      "Real-time payment tracking",
      "Automated financial reporting",
      "Multi-currency support",
      "API integrations",
      "Mobile payment options",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      payperProject1,
      payperProject2,
      payperProject3,
      payperProject4,
      payperProject5,
    ],
  },
  {
    id: "18",
    pImg: TutorNearby8,
    title: "Tutor-Nearby - Online Tutoring Platform",
    slug: "tutor-nearby-online-tutoring",
    sub: "Education Technology",
    description:
      "Tutor-Nearby is a comprehensive online tutoring platform that connects students with qualified tutors in their vicinity. The platform offers personalized learning experiences, real-time scheduling, and progress tracking to enhance educational outcomes.",
    services: " Online Education & Tutoring Services",
    Industry: " Education Technology",
    location: " Global",
    projectRequirement: "The project required the development of a user-friendly online tutoring platform with features for tutor-student matching, scheduling, payment processing, and learning management.",
    completedDate: " 01-12-2024",
    category: "education",
    solutionResult: "Tutor-Nearby was built as a scalable edtech platform that facilitates seamless connections between tutors and students. The solution includes advanced matching algorithms, secure video conferencing, automated scheduling, and comprehensive progress reporting.",
    features: [
      "Tutor-student matching algorithm",
      "Real-time video tutoring sessions",
      "Flexible scheduling system",
      "Progress tracking and reporting",
      "Secure payment processing",
      "Mobile-responsive design",
      "Rating and review system",
      "Multi-subject support",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      tutorNearby1,
      tutorNearby2,
      tutorNearby3,
      tutorNearby4,
    ],
  },
  {
    id: "19",
    pImg: GreenBell8,
    title: "Green-Bell-Packaging - Sustainable Packaging Solutions",
    slug: "green-bell-packaging-sustainable",
    sub: "Sustainable Packaging",
    description:
      "Green-Bell-Packaging provides eco-friendly packaging solutions for businesses looking to reduce their environmental impact. The platform offers customizable sustainable packaging options, supply chain management, and compliance tracking.",
    services: " Sustainable Packaging & Supply Chain",
    Industry: " Manufacturing & Sustainability",
    location: " Global",
    projectRequirement: "The project required the development of a platform for managing sustainable packaging solutions, including supplier networks, customization tools, and environmental impact tracking.",
    completedDate: " 05-12-2024",
    category: "business",
    solutionResult: "Green-Bell-Packaging was developed as a comprehensive platform for sustainable packaging management. The solution includes supplier marketplace, customization tools, environmental impact calculators, and compliance reporting features.",
    features: [
      "Sustainable material sourcing",
      "Custom packaging design tools",
      "Environmental impact assessment",
      "Supplier network management",
      "Compliance tracking",
      "Order management system",
      "Sustainability reporting",
      "Multi-language support",
    ],
    Technologies1: tImg1,
    Technologies2: tImg5,
    additionalImages: [
      greenBellPackaging1,
      greenBellPackaging2,
      greenBellPackaging3,
      greenBellPackaging4,
      greenBellPackaging5,
    ],
  },
  {
    id: "20",
    pImg: boltan2,
    title: "Bolton Road Dental Practice - Modern Dental Care Website",
    slug: "bolton-road-dental-practice",
    sub: "Healthcare Website",
    description:
      "Bolton Road Dental Practice offers comprehensive dental care services with a modern, patient-centered approach. The website showcases their services, team, and facilities, providing an easy way for patients to book appointments and learn about dental health.",
    services: " Dental Care Website Development",
    Industry: " Healthcare",
    location: " Bolton, UK",
    projectRequirement: "The project required the creation of a professional dental practice website with appointment booking, service information, team profiles, and patient resources.",
    completedDate: " 10-12-2024",
    category: "healthcare",
    solutionResult: "A modern, responsive website was developed for Bolton Road Dental Practice, featuring online appointment booking, service descriptions, team information, and patient education resources.",
    features: [
      "Online appointment booking system",
      "Service information and pricing",
      "Team profiles and credentials",
      "Patient education resources",
      "Contact information and location details",
      "Mobile-responsive design",
      "SEO optimization for local search",
      "Integration with practice management software",
    ],
    Technologies1: tImg1,
    Technologies2: tImg6,
    additionalImages: [
      boltan1,
      boltan2,
      boltan3,
      boltan4,
      boltan5,
    ],
  },
];
export default Project;
